"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = useTableDonations;
const react_1 = require("react");
function useTableDonations(donations) {
    return (0, react_1.useMemo)(() => {
        return donations.filter((donation) => { var _a; return (_a = donation.displayInTable) !== null && _a !== void 0 ? _a : false; });
    }, [donations]);
}
